import { message } from "antd";
import { CRMService } from "../../services/apiServices/crmService";
import { TaskService } from "../../services/apiServices/taskService";
import moment from "moment";

// Action Types
export const GET_CRM_RECEIVERS_REQUEST = 'GET_CRM_RECEIVERS_REQUEST';
export const GET_CRM_RECEIVERS_SUCCESS = 'GET_CRM_RECEIVERS_SUCCESS';
export const GET_CRM_RECEIVERS_FAILURE = 'GET_CRM_RECEIVERS_FAILURE';

export const LOAD_MORE_CRM_RECEIVERS_REQUEST = 'LOAD_MORE_CRM_RECEIVERS_REQUEST';
export const LOAD_MORE_CRM_RECEIVERS_SUCCESS = 'LOAD_MORE_CRM_RECEIVERS_SUCCESS';
export const LOAD_MORE_CRM_RECEIVERS_FAILURE = 'LOAD_MORE_CRM_RECEIVERS_FAILURE';

export const GET_CRM_RECEIVERS_TOTAL_REQUEST = 'GET_CRM_RECEIVERS_TOTAL_REQUEST';
export const GET_CRM_RECEIVERS_TOTAL_SUCCESS = 'GET_CRM_RECEIVERS_TOTAL_SUCCESS';
export const GET_CRM_RECEIVERS_TOTAL_FAILURE = 'GET_CRM_RECEIVERS_TOTAL_FAILURE';

export const GET_CRM_COMPANIES_REQUEST = 'GET_CRM_COMPANIES_REQUEST';
export const GET_CRM_COMPANIES_SUCCESS = 'GET_CRM_COMPANIES_SUCCESS';
export const GET_CRM_COMPANIES_FAILURE = 'GET_CRM_COMPANIES_FAILURE';

export const LOAD_MORE_CRM_COMPANIES_REQUEST = 'LOAD_MORE_CRM_COMPANIES_REQUEST';
export const LOAD_MORE_CRM_COMPANIES_SUCCESS = 'LOAD_MORE_CRM_COMPANIES_SUCCESS';
export const LOAD_MORE_CRM_COMPANIES_FAILURE = 'LOAD_MORE_CRM_COMPANIES_FAILURE';

export const GET_CRM_COMPANIES_TOTAL_REQUEST = 'GET_CRM_COMPANIES_TOTAL_REQUEST';
export const GET_CRM_COMPANIES_TOTAL_SUCCESS = 'GET_CRM_COMPANIES_TOTAL_SUCCESS';
export const GET_CRM_COMPANIES_TOTAL_FAILURE = 'GET_CRM_COMPANIES_TOTAL_FAILURE';

export const SET_CRM_FILTERS = 'SET_CRM_FILTERS';
export const CLEAR_CRM_FILTERS = 'CLEAR_CRM_FILTERS';

export const EXPORT_CRM_RECEIVERS_REQUEST = 'EXPORT_CRM_RECEIVERS_REQUEST';
export const EXPORT_CRM_RECEIVERS_SUCCESS = 'EXPORT_CRM_RECEIVERS_SUCCESS';
export const EXPORT_CRM_RECEIVERS_FAILURE = 'EXPORT_CRM_RECEIVERS_FAILURE';

export const EXPORT_CRM_COMPANIES_REQUEST = 'EXPORT_CRM_COMPANIES_REQUEST';
export const EXPORT_CRM_COMPANIES_SUCCESS = 'EXPORT_CRM_COMPANIES_SUCCESS';
export const EXPORT_CRM_COMPANIES_FAILURE = 'EXPORT_CRM_COMPANIES_FAILURE';

export const RUN_SAVE_CONNECTIONS_REQUEST = 'RUN_SAVE_CONNECTIONS_REQUEST';
export const RUN_SAVE_CONNECTIONS_SUCCESS = 'RUN_SAVE_CONNECTIONS_SUCCESS';
export const RUN_SAVE_CONNECTIONS_FAILURE = 'RUN_SAVE_CONNECTIONS_FAILURE';

// Action Creators
export const crmActions = {
  getCRMReceivers,
  loadMoreCRMReceivers,
  getCRMReceiversTotal,
  getCRMCompanies,
  loadMoreCRMCompanies,
  getCRMCompaniesTotal,
  setCRMFilters,
  clearCRMFilters,
  exportCRMReceivers,
  exportCRMCompanies,
  runSaveConnections,
};

// Get CRM Receivers
function getCRMReceivers(filters: any = {}) {
  return async (dispatch: any, getState: any) => {
    try {
      dispatch(request());
      const response = await CRMService.getReceivers(filters);
      dispatch(success(response.data.receivers || response.data));
    } catch (error) {
      dispatch(failure(error.message || 'Failed to fetch CRM receivers'));
    }
  };

  function request() {
    return { type: GET_CRM_RECEIVERS_REQUEST };
  }

  function success(receivers: any) {
    return { type: GET_CRM_RECEIVERS_SUCCESS, receivers };
  }

  function failure(error: string) {
    return { type: GET_CRM_RECEIVERS_FAILURE, error };
  }
}

// Load More CRM Receivers
function loadMoreCRMReceivers(filters: any = {}) {
  return async (dispatch: any, getState: any) => {
    try {
      dispatch(request());
      const response = await CRMService.getReceivers(filters);
      dispatch(success(response.data.receivers || response.data));
    } catch (error) {
      dispatch(failure(error.message || 'Failed to load more CRM receivers'));
    }
  };

  function request() {
    return { type: LOAD_MORE_CRM_RECEIVERS_REQUEST };
  }

  function success(receivers: any) {
    return { type: LOAD_MORE_CRM_RECEIVERS_SUCCESS, receivers };
  }

  function failure(error: string) {
    return { type: LOAD_MORE_CRM_RECEIVERS_FAILURE, error };
  }
}

// Get CRM Receivers Total
function getCRMReceiversTotal(filters: any = {}) {
  return async (dispatch: any, getState: any) => {
    try {
      dispatch(request());
      const response = await CRMService.getReceiversTotal(filters);
      dispatch(success(response.data.total));
    } catch (error) {
      dispatch(failure(error.message || 'Failed to fetch CRM receivers total'));
    }
  };

  function request() {
    return { type: GET_CRM_RECEIVERS_TOTAL_REQUEST };
  }

  function success(total: number) {
    return { type: GET_CRM_RECEIVERS_TOTAL_SUCCESS, total };
  }

  function failure(error: string) {
    return { type: GET_CRM_RECEIVERS_TOTAL_FAILURE, error };
  }
}

// Get CRM Companies
function getCRMCompanies(filters: any = {}) {
  return async (dispatch: any, getState: any) => {
    try {
      dispatch(request());
      const response = await CRMService.getCompanies(filters);
      dispatch(success(response.data.companies || response.data));
    } catch (error) {
      dispatch(failure(error.message || 'Failed to fetch CRM companies'));
    }
  };

  function request() {
    return { type: GET_CRM_COMPANIES_REQUEST };
  }

  function success(companies: any) {
    return { type: GET_CRM_COMPANIES_SUCCESS, companies };
  }

  function failure(error: string) {
    return { type: GET_CRM_COMPANIES_FAILURE, error };
  }
}

// Load More CRM Companies
function loadMoreCRMCompanies(filters: any = {}) {
  return async (dispatch: any, getState: any) => {
    try {
      dispatch(request());
      const response = await CRMService.getCompanies(filters);
      dispatch(success(response.data.companies || response.data));
    } catch (error) {
      dispatch(failure(error.message || 'Failed to load more CRM companies'));
    }
  };

  function request() {
    return { type: LOAD_MORE_CRM_COMPANIES_REQUEST };
  }

  function success(companies: any) {
    return { type: LOAD_MORE_CRM_COMPANIES_SUCCESS, companies };
  }

  function failure(error: string) {
    return { type: LOAD_MORE_CRM_COMPANIES_FAILURE, error };
  }
}

// Get CRM Companies Total
function getCRMCompaniesTotal(filters: any = {}) {
  return async (dispatch: any, getState: any) => {
    try {
      dispatch(request());
      const response = await CRMService.getCompaniesTotal(filters);
      dispatch(success(response.data.total));
    } catch (error) {
      dispatch(failure(error.message || 'Failed to fetch CRM companies total'));
    }
  };

  function request() {
    return { type: GET_CRM_COMPANIES_TOTAL_REQUEST };
  }

  function success(total: number) {
    return { type: GET_CRM_COMPANIES_TOTAL_SUCCESS, total };
  }

  function failure(error: string) {
    return { type: GET_CRM_COMPANIES_TOTAL_FAILURE, error };
  }
}

// Set CRM Filters
function setCRMFilters(filters: any) {
  return (dispatch: any, getState: any) => {
    const clientId = getState().client.data.id;
    const settings = getState().settings;
    settings[clientId] = { ...settings[clientId], crmFilters: filters };
    dispatch({ type: SET_CRM_FILTERS, filters });
  };
}

// Clear CRM Filters
function clearCRMFilters() {
  return { type: CLEAR_CRM_FILTERS };
}

// Export CRM Receivers
function exportCRMReceivers(filters: any = {}) {
  return async (dispatch: any, getState: any) => {
    try {
      dispatch(request());
      const response = await CRMService.exportReceivers(filters);

      // Create download link for CSV
      const blob = new Blob([response.data], { type: 'text/csv' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `cuegrowth_receivers_${moment().format('YYYY-MM-DD_HH-mm-ss')}.csv`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);

      dispatch(success());
    } catch (error) {
      dispatch(failure(error.message || 'Failed to export CRM receivers'));
    }
  };

  function request() {
    return { type: EXPORT_CRM_RECEIVERS_REQUEST };
  }

  function success() {
    return { type: EXPORT_CRM_RECEIVERS_SUCCESS };
  }

  function failure(error: string) {
    return { type: EXPORT_CRM_RECEIVERS_FAILURE, error };
  }
}

// Export CRM Companies
function exportCRMCompanies(filters: any = {}) {
  return async (dispatch: any, getState: any) => {
    try {
      dispatch(request());
      const response = await CRMService.exportCompanies(filters);

      // Create download link for CSV
      const blob = new Blob([response.data], { type: 'text/csv' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `cuegrowth_companies_${moment().format('YYYY-MM-DD_HH-mm-ss')}.csv`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);

      dispatch(success());
    } catch (error) {
      dispatch(failure(error.message || 'Failed to export CRM companies'));
    }
  };

  function request() {
    return { type: EXPORT_CRM_COMPANIES_REQUEST };
  }

  function success() {
    return { type: EXPORT_CRM_COMPANIES_SUCCESS };
  }

  function failure(error: string) {
    return { type: EXPORT_CRM_COMPANIES_FAILURE, error };
  }
}

function runSaveConnections(params: { user_id: number }) {
  return async (dispatch: any, getState: any) => {
    try {
      dispatch(request());
      const response = await TaskService.postTask({
        ...params,
        code: 'run_save_connection_immediately',
        status: 'created',
      });
      message.success('Syncing connections started');
      dispatch(success(response.data));
    } catch (error) {
      message.error('Failed to run save connections');
      dispatch(failure(error.message || 'Failed to run save connections'));
    }
  };

  function request() {
    return { type: RUN_SAVE_CONNECTIONS_REQUEST };
  }

  function success(response: any) {
    return { type: RUN_SAVE_CONNECTIONS_SUCCESS, response };
  }

  function failure(error: string) {
    return { type: RUN_SAVE_CONNECTIONS_FAILURE, error };
  }
}
